export const paths = {
  team: '/team',
};
